import { render, staticRenderFns } from "./FormRecovery.vue?vue&type=template&id=16585417&scoped=true"
import script from "./FormRecovery.vue?vue&type=script&lang=js"
export * from "./FormRecovery.vue?vue&type=script&lang=js"
import style0 from "./FormRecovery.vue?vue&type=style&index=0&id=16585417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16585417",
  null
  
)

export default component.exports